import AppSettings from "../Settings/AppSettings";
import ServiceWrapper from "../Services/ServiceWrapper";
import AuthManager from "./AuthManager";

class Logger {
  static async log(logType, module, message, partyId) {
    if (!AppSettings.LOGS_ENABLED) return;

    let userid = -1;
    let username = AppSettings.APP_NAME;
    if (AuthManager.isAuthenticated()) {
      var userobj = AuthManager.getAuthUser();
      if (
        !(
          userobj === null ||
          userobj === undefined ||
          userobj.profile === null ||
          userobj.profile === undefined
        )
      )
        userid = userobj.profile.id;
      username = userobj.profile.first_name + " " + userobj.profile.last_name;
    }
    var api_base_url = AppSettings.GMS_BACKEND_API_URL;

    await ServiceWrapper.doPost(
      api_base_url + "gms/log/write",
      {
        logType: logType,
        moduleName: module,
        userId: userid,
        userName: username,
        description: message,
        partyId: partyId,
        sourceName: AppSettings.APP_NAME,
      },
      null,
      AuthManager.getGmsToken()
    );
  }
}

export default Logger;
